"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selects = exports.SingleSelect = exports.NoOptionsInfo = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var index_1 = require("../../../lib/customHooks/index");
var ListItemIndexesForRenderingHandler_1 = __importDefault(require("./ListItemIndexesForRenderingHandler"));
var useDynamiceRenderList_1 = __importDefault(require("./useDynamiceRenderList"));
var EmptyListItem_1 = __importDefault(require("./EmptyListItem"));
var CopyButton_1 = __importDefault(require("./CopyButton"));
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {},
    singleSelect: {
        '& svg': {
            display: 'none',
        },
        '&:hover svg': {
            display: 'block'
        }
    }
}); });
exports.NoOptionsInfo = function (_a) {
    var input = _a.input;
    var noOptionText = (react_1.default.createElement(core_1.Box, null,
        react_1.default.createElement(core_1.Box, { component: 'span' }, 'No result matched '),
        react_1.default.createElement(core_1.Box, { component: 'span', style: {
                fontWeight: 800,
            } }, input)));
    return (react_1.default.createElement(core_1.ListItem, null,
        react_1.default.createElement(core_1.ListItemText, { primary: noOptionText })));
};
exports.SingleSelect = react_1.forwardRef(function (_a, ref) {
    var option = _a.option, isSelected = _a.isSelected, clickFn = _a.clickFn;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { display: 'flex', alignItems: 'center', className: classes.singleSelect },
        react_1.default.createElement(core_1.ListItem, { ref: ref, selected: isSelected, onClick: clickFn, button: true },
            react_1.default.createElement(core_1.ListItemText, { primary: option.text })),
        react_1.default.createElement(CopyButton_1.default, { copyText: option.text })));
});
exports.Selects = function (_a) {
    var filterInput = _a.filterInput, filteredOptions = _a.filteredOptions, selectedIndex = _a.selectedIndex, filterFn = _a.filterFn, selectFn = _a.selectFn, closeSelectsFn = _a.closeSelectsFn;
    var optionsLength = filteredOptions.length;
    var classes = styles_1.useStylesSelectsInFilter();
    var _b = useDynamiceRenderList_1.default(filteredOptions, selectedIndex), listPartRef = _b.listPartRef, listRefs = _b.listRefs, startToEndIndexesForRendering = _b.startToEndIndexesForRendering, handleScroll = _b.handleScroll;
    var singleOptionFn = function (singleOption, i) {
        var singleSelect = (react_1.default.createElement(exports.SingleSelect, { key: i, ref: listRefs.current[i], option: singleOption, isSelected: selectedIndex === i, clickFn: handleSelectRoute(i) }));
        var emptyListItem = (react_1.default.createElement(EmptyListItem_1.default, { key: i, ref: listRefs.current[i] }));
        var Component = ListItemIndexesForRenderingHandler_1.default.getSingleSelectOrEmptyListItemByCheckShouldRender(i, startToEndIndexesForRendering)(singleSelect, emptyListItem);
        return Component;
    };
    var handleSelectRoute = react_1.useCallback(function (index) {
        return function () {
            if (selectFn) {
                selectFn(index);
            }
        };
    }, [selectFn]);
    var handleClose = react_1.useCallback(function () {
        if (closeSelectsFn) {
            closeSelectsFn();
        }
    }, [closeSelectsFn]);
    index_1.useScrollToSingleSelect(listRefs, selectedIndex);
    //console.log(startToEndIndexesForRendering);
    return (react_1.default.createElement(core_1.Box, { className: classes && classes.root },
        react_1.default.createElement(core_1.Paper, null,
            react_1.default.createElement(core_1.Box, { padding: 1 },
                react_1.default.createElement(core_1.TextField, { fullWidth: true, autoFocus: true, variant: 'outlined', onChange: filterFn, value: filterInput })),
            react_1.default.createElement(core_1.RootRef, { rootRef: listPartRef },
                react_1.default.createElement(core_1.Box, { className: classes.selects, onScroll: handleScroll }, optionsLength > 0 ? (filteredOptions.map(singleOptionFn)) : (react_1.default.createElement(exports.NoOptionsInfo, { input: filterInput }))))),
        react_1.default.createElement(core_1.Box, { id: 'selectsInFilterBG', className: classes.clickBG, onClick: handleClose })));
};
exports.default = react_1.memo(exports.Selects);
